/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreditCardEarnings } from './CreditCardEarnings';
import {
    CreditCardEarningsFromJSON,
    CreditCardEarningsFromJSONTyped,
    CreditCardEarningsToJSON,
    CreditCardEarningsToJSONTyped,
} from './CreditCardEarnings';

/**
 * Earnings summary
 * @export
 * @interface EarningsSummary
 */
export interface EarningsSummary {
    /**
     * 
     * @type {number}
     * @memberof EarningsSummary
     */
    gondolaCashbackPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof EarningsSummary
     */
    loyaltyEarningsPercentage?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof EarningsSummary
     */
    creditCardEarningsPercentage?: Array<number>;
    /**
     * 
     * @type {Array<CreditCardEarnings>}
     * @memberof EarningsSummary
     */
    syncedCardEarnings?: Array<CreditCardEarnings>;
    /**
     * 
     * @type {Array<number>}
     * @memberof EarningsSummary
     */
    otherSites?: Array<number>;
}

/**
 * Check if a given object implements the EarningsSummary interface.
 */
export function instanceOfEarningsSummary(value: object): value is EarningsSummary {
    return true;
}

export function EarningsSummaryFromJSON(json: any): EarningsSummary {
    return EarningsSummaryFromJSONTyped(json, false);
}

export function EarningsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarningsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaCashbackPercentage': json['gondola_cashback_percentage'] == null ? undefined : json['gondola_cashback_percentage'],
        'loyaltyEarningsPercentage': json['loyalty_earnings_percentage'] == null ? undefined : json['loyalty_earnings_percentage'],
        'creditCardEarningsPercentage': json['credit_card_earnings_percentage'] == null ? undefined : json['credit_card_earnings_percentage'],
        'syncedCardEarnings': json['synced_card_earnings'] == null ? undefined : ((json['synced_card_earnings'] as Array<any>).map(CreditCardEarningsFromJSON)),
        'otherSites': json['other_sites'] == null ? undefined : json['other_sites'],
    };
}

export function EarningsSummaryToJSON(json: any): EarningsSummary {
    return EarningsSummaryToJSONTyped(json, false);
}

export function EarningsSummaryToJSONTyped(value?: EarningsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_cashback_percentage': value['gondolaCashbackPercentage'],
        'loyalty_earnings_percentage': value['loyaltyEarningsPercentage'],
        'credit_card_earnings_percentage': value['creditCardEarningsPercentage'],
        'synced_card_earnings': value['syncedCardEarnings'] == null ? undefined : ((value['syncedCardEarnings'] as Array<any>).map(CreditCardEarningsToJSON)),
        'other_sites': value['otherSites'],
    };
}

